import React, { ReactNode } from "react";

import { BottomState as LayoutBottomState } from "ducks/layout/layout";

export interface MainProps {
  bottomSlot?: React.ReactNode;
  bottomState?: LayoutBottomState;
  bottomHeight?: number;
}

export enum Areas {
  Bottom = "bottom",
  Main = "main",
  MainControls = "mainControls",
  AdditionalControls = "additionalControls",
  Panel = "panel",
  Presentation = "presentation",
  Portal = "portal",
  ObjectCard = "objectCard",
  BottomState = "bottomState",
  BottomHeight = "bottomHeight",
  TopControls = "topControls",
}

export type LayoutProps = {
  [Areas.Main]?: ReactNode;
  [Areas.Panel]?: ReactNode;
  [Areas.Presentation]?: ReactNode;
  [Areas.Bottom]?: ReactNode;
  [Areas.AdditionalControls]?: ReactNode;
  [Areas.Portal]?: ReactNode;
  [Areas.MainControls]?: ReactNode;
  [Areas.TopControls]?: ReactNode;
  [Areas.ObjectCard]?: ReactNode;
  [Areas.BottomState]?: LayoutBottomState;
  [Areas.BottomHeight]?: number;
};

export type ContainerProps = Pick<MainProps, "bottomState">;

export interface SharedLayoutProps {
  [Areas.Main]?: ReactNode;
  [Areas.Panel]?: ReactNode;
  [Areas.Bottom]?: ReactNode;
  [Areas.AdditionalControls]?: ReactNode;
  [Areas.Portal]?: ReactNode;
  [Areas.MainControls]?: ReactNode;
  [Areas.TopControls]?: ReactNode;
  [Areas.BottomState]?: LayoutBottomState;
  [Areas.BottomHeight]?: number;
}

export type PanelContainerProps = {
  resizable?: boolean;
  width?: string;
  flex?: string;
};
